<template>
  <div
    :class="[styles.card, computedStyles]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppCard',

  props: {
    dataLayer: {
      type: String,
      required: false,
      default: ''
    },
    // square: {
    //   type: Boolean,
    //   required: false,
    //   default: false
    // },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    // bgColor: {
    //   type: String,
    //   required: false,
    //   default: ''
    // },
    borderBottom: {
      type: Boolean,
      required: false,
      default: false
    },
    // borderColor: {
    //   type: String,
    //   required: false,
    //   default: ''
    // },
    rounded: {
      type: String,
      required: false,
      default: 'rounded-15'
    }
  },

  data () {
    return {
      styles: {
        card: [
          'app-card'
        ]
      }
    }
  },

  computed: {
    computedStyles () {
      return [
        this.rounded,
        {
          // 'rounded-15': !this.square,
          'shadow': !this.flat,
          // [`bg-${this.bgColor}`]: this.bgColor,
          'bg-white': !this.bgColor,
          'border-b-10': this.borderBottom
          // [`border-${this.borderColor}`]: this.borderColor
        }
      ]
    }
  }
}
</script>
